export const options = [
  { label: "Anytime", value: "ANYTIME" },
  { label: "Morning", value: "MORNING" },
  { label: "Afternoon", value: "AFTERNOON" },
  { label: "Evening", value: "EVENING" }
];
